import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import ResetPassword from 'views/pages/authentication/authentication3/ResetPassword';

// login option 3 routing
const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
const AuthRegister3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Register3')));
const ChangePassword = Loadable(lazy(() => import('views/pages/authentication/authentication3/ChangePassword')));
const ForgotPassword = Loadable(lazy(() => import('views/pages/authentication/authentication3/ForgotPassword')));
const RegisterResponse = Loadable(lazy(() => import('views/pages/authentication/auth-forms/registermessage')));
const Home = Loadable(lazy(() => import('views/home')));
const VerifyAccount = Loadable(lazy(() => import('views/pages/authentication/auth-forms/VerifyAccount')));
const AboutUs = Loadable(lazy(() => import('views/pages/AboutUs')));
const ContactUs = Loadable(lazy(() => import('views/pages/ContactUs')));



// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: '/',
      element: <Home />
    },
    {
      path: '/login',
      element: <AuthLogin3 />
    },
    {
      path: '/register',
      element: <AuthRegister3 />
    },
    {
      path: '/forgotpassword',
      element: <ForgotPassword />
    },
    {
      path: '/registerresponse',
      element: <RegisterResponse />
    },
    {
      path: '/verifyaccount',
      element: <VerifyAccount />
    },
    {
      path: '/resetpassword',
      element: <ResetPassword />
    },
    {
      path: '/contactus',
      element: <ContactUs />
    },
    {
      path: '/aboutus',
      element: <AboutUs />
    },
  ]
};

export default AuthenticationRoutes;
